import { render, staticRenderFns } from "./ModalSubmitEvidenceDetails.vue?vue&type=template&id=3ec0b8af&scoped=true&"
import script from "./ModalSubmitEvidenceDetails.vue?vue&type=script&lang=js&"
export * from "./ModalSubmitEvidenceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubmitEvidenceDetails.vue?vue&type=style&index=0&id=3ec0b8af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec0b8af",
  null
  
)

export default component.exports